import React from 'react';
import clsx from 'clsx';
import styles from './MultiStepForm.module.css';
import { MultiStepFormStep } from './Step/MultiStepFormStep';

export interface Step {
    title: string;
    description?: string | React.ReactNode;
    tooltip?: string | React.ReactNode;
    component: React.ReactNode;
}

interface MultiStepFormProps {
    activeStep: number;
    steps: Array<Step>;
    className?: string;
    titleClassName?: string;
    titleContainerClassName?: string;
    contentClassName?: string;
    onEdit: (step: number) => void;
}

export const MultiStepForm: React.FC<MultiStepFormProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            {props.steps.map((step, index) => (
                <MultiStepFormStep
                    key={index}
                    step={step}
                    index={index}
                    stepNumber={index + 1}
                    isCompleted={props.activeStep > index}
                    isActive={props.activeStep === index}
                    titleClassName={props.titleClassName}
                    titleContainerClassName={props.titleContainerClassName}
                    contentClassName={props.contentClassName}
                    onEdit={props.onEdit}
                />
            ))}
        </div>
    );
};
